import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h4>{`Senior full-stack engineer & solution architect`}</h4>
    <p>{`Seasoned Senior Software Engineer with focus on authentication protocols, identity management, and decentralization ecosystems.
I bring a potent combination of a product-centric approach and deep technological expertise to every challenge.`}</p>
    <p><strong parentName="p">{`Selected work`}</strong></p>
    <ul>
      <li parentName="ul">{`Authentication and wallet infrastructure for Web3 products, including passkeys, OIDC, MPC wallets, and smart accounts (ERC-4337, EIP-7702)`}</li>
      <li parentName="ul">{`Lead engineer and architect on client products in healthcare, video processing, accounting, construction, and 3D scanning`}</li>
    </ul>
    <p><strong parentName="p">{`Stack`}</strong></p>
    <ul>
      <li parentName="ul">{`TypeScript / Node.js, Python, Go`}</li>
      <li parentName="ul">{`React, Next.js, NestJS, FastAPI`}</li>
      <li parentName="ul">{`OAuth 2.x / OpenID Connect, passkeys (WebAuthn)`}</li>
      <li parentName="ul">{`EVM, Solana, account abstraction, MPC wallets`}</li>
      <li parentName="ul">{`AWS, Google Cloud, Azure, Terraform, Kubernetes`}</li>
      <li parentName="ul">{`Airflow, Dagster, Step Functions, BigQuery, Redshift`}</li>
      <li parentName="ul">{`LLM integrations: RAG, agents, AI APIs`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      